import { Color } from "./base-data";

const colors: Color[][] = [
  ["G", "G", "O", "O", "O", "R", "R", "R", "Y", "B", "B", "B", "B", "B", "R"],
  ["R", "O", "O", "Y", "G", "G", "B", "Y", "Y", "Y", "G", "O", "O", "O", "R"],
  ["B", "B", "B", "R", "G", "G", "B", "Y", "R", "R", "R", "O", "G", "O", "O"],
  ["B", "B", "R", "R", "R", "G", "G", "O", "O", "R", "Y", "G", "G", "G", "G"],
  ["B", "R", "R", "B", "B", "B", "O", "B", "B", "O", "Y", "Y", "Y", "Y", "B"],
  ["O", "Y", "G", "G", "B", "O", "O", "G", "B", "O", "O", "Y", "R", "R", "Y"],
  ["Y", "Y", "Y", "G", "Y", "Y", "Y", "G", "G", "G", "O", "R", "R", "R", "Y"],
];

const stars: boolean[][] = [
  [
    false,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
  ],
  [
    true,
    false,
    false,
    true,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
  ],
  [
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
];

export const board = { colors, stars };
